var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7784 2.20934C17.0575 1.93022 17.5101 1.93022 17.7892 2.20933L18.7936 3.21372C19.0728 3.49284 19.0728 3.9454 18.7936 4.22453L12.6839 10.3344C12.6179 10.4004 12.5396 10.4528 12.4535 10.4887L9.12769 11.8752L10.5143 8.54951C10.5502 8.46339 10.6026 8.38514 10.6686 8.31916L16.7784 2.20934ZM19.2034 0.795088C18.1432 -0.265047 16.4243 -0.265026 15.3642 0.79513L9.25437 6.90495C9.00378 7.15554 8.80468 7.45276 8.66831 7.77985L7.14834 11.4254C6.50996 12.9565 8.04622 14.4928 9.57735 13.8546L13.2231 12.3347C13.5502 12.1984 13.8475 11.9992 14.0981 11.7486L20.2079 5.63873C21.268 4.57853 21.268 2.85963 20.2078 1.79947L19.2034 0.795088ZM5 2C2.23858 2 0 4.23858 0 7V15C0 17.7614 2.23858 20 5 20H13C15.7614 20 18 17.7614 18 15V13C18 12.4477 17.5523 12 17 12C16.4477 12 16 12.4477 16 13V15C16 16.6569 14.6569 18 13 18H5C3.34315 18 2 16.6569 2 15V7C2 5.34315 3.34315 4 5 4H9C9.55229 4 10 3.55228 10 3C10 2.44772 9.55229 2 9 2H5Z",
    fill: "#0A51C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessage);
export default __webpack_public_path__ + "static/media/new-message.539e9901ef25f48f62ec3fcb91989081.svg";
export { ForwardRef as ReactComponent };